import { Navigate } from "react-router-dom";
import { useAuth, type Role } from "../lib/auth";

export function ProtectedRoute({ roles, children }: { roles: Role[]; children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="container">
        <p>Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/staff/login" replace />;
  if (!roles.includes(user.role)) {
    return (
      <div className="container">
        <div className="card">
          <h2>Access restricted</h2>
          <p>Your account does not have permission to view this page.</p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
